import styled from 'styled-components';
import Tag from 'antd/lib/tag';

const Shape = Tag;

export const StyledShape = styled(Shape)`
  margin-bottom: 5px;
`;
